<template>
  <v-container fluid>
    <template v-if="message">

      <PageTitle icon="fal fa-fw fa-fax">
        Fax Message {{ message.id }}
        <template v-slot:buttons>
          <v-btn :to="{name: `${$root.routePrefix}.send_fax`}"
                 color="primary"
                 class="mr-2">
            Send fax
          </v-btn>
          <v-btn :to="{name: `${$root.routePrefix}.fax_messages.index`}"
                 exact
                 class="mr-2">
            Fax Messages
          </v-btn>
          <v-btn :to="{name: `${$root.routePrefix}.fax_contacts.index`}"
                 exact
                 class="mr-2">
            Fax Contacts
          </v-btn>
        </template>
      </PageTitle>

      <v-card class="mb-4">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <th>
                Sender
              </th>
              <td>
                {{ message.user.name }}
              </td>
            </tr>
            <tr>
              <th>
                Recipient
              </th>
              <td>
                {{ message.name }}
              </td>
            </tr>
            <tr>
              <th>
                Company
              </th>
              <td>
                {{ message.company_name }}
              </td>
            </tr>
            <tr>
              <th>
                Fax Number
              </th>
              <td>
                {{ message.fax_number_national }}
              </td>
            </tr>
            <tr>
              <th>
                Sent
              </th>
              <td>
                {{ message.created_at | datetime('MMMM D, YYYY h:mm a') }}
              </td>
            </tr>
            <tr>
              <th>
                Presentation
              </th>
              <td>
                {{ message.presentation.name }}
              </td>
            </tr>
            <tr>
              <th>
                Pages
              </th>
              <td>
                {{ message.pages_complete }} of {{ message.pages_count }} complete
              </td>
            </tr>
            <tr>
              <th>
                Status
              </th>
              <td>
                {{ message.status }}
              </td>
            </tr>
            <tr>
              <th>
                Cover Page Message
              </th>
              <td>
                <pre>{{ message.notes }}</pre>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <v-card>
        <v-card-title>
          Events
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="events"
                      item-key="id">
          <template v-slot:item.created_at="{item: event}">
            {{ event.created_at | datetime('MMM D, YYYY h:mm a') }}
          </template>
        </v-data-table>
      </v-card>
    </template>
  </v-container>
</template>
<script>
import faxService from '../../../services/faxService';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
      message: null,
      events: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Date',
          value: 'created_at',
        },
        { // MLD-6682
          text: 'Event',
          value: 'name',
        },
        {
          text: 'Direction',
          value: 'direction',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Attempt',
          value: 'fax_attempt',
        },
        {
          text: 'Result Code',
          value: 'result_code',
        },
        {
          text: 'Result Info',
          value: 'result_info',
        },
      ]
    },
    messageID() {
      return parseInt(this.$route.params.messageID);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.busy = true;
      try {
        this.message = await faxService.getMessage(this.messageID)
        this.events = await faxService.getEvents(this.messageID);
      } catch (e) {
        this.$toast.error('Fax message not found.');
        await this.$router.replace({name: `${this.$root.routePrefix}.fax_messages.index`});
      } finally {
        this.busy = false;
      }
    }
  }
}
</script>
